import { render, staticRenderFns } from "./spaces-explainer-desktop.vue?vue&type=template&id=152d138b&scoped=true&"
import script from "./spaces-explainer-desktop.vue?vue&type=script&lang=js&"
export * from "./spaces-explainer-desktop.vue?vue&type=script&lang=js&"
import style0 from "./spaces-explainer-desktop.vue?vue&type=style&index=0&id=152d138b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d138b",
  null
  
)

export default component.exports